import { FC, ReactNode } from 'react'
import Logo from 'builder/components/Logo'
import Icon from 'builder/components/Icon'
import {
  Main,
  Container,
  Navbar,
  SkipButton,
  StepsWrapper,
  CloseButton,
  Title,
  HeaderButtonsContainer,
} from './styles'
import TemplateGuestSteps from './TemplateGuestSteps'
import { useMainAppContext } from './context/TemplatesGuestContext'

type LayoutProps = {
  regionPrefix: string
  skipTemplatesVariant?: 'v1' | 'v2'
  pickTemplateAfterUploadVariant?: boolean | 'v0' | 'v1' | 'v2'
  handleSkipButton: () => void
  handleExitButton?: () => void
  children: ReactNode
}

const TemplatesLayout: FC<LayoutProps> = ({
  children,
  regionPrefix,
  handleSkipButton,
  handleExitButton,
  skipTemplatesVariant,
  pickTemplateAfterUploadVariant,
  ...rest
}) => {
  const { currentStepName } = useMainAppContext()
  const homepageUrl = `/${regionPrefix}`

  const showTitleAb =
    ['v2', 'v1'].includes(skipTemplatesVariant || '') || pickTemplateAfterUploadVariant === 'v2'

  return (
    <Container {...rest}>
      <Navbar>
        <a aria-label="Logo" href={homepageUrl}>
          <Logo />
        </a>

        {currentStepName !== 'templates' && (
          <StepsWrapper>
            <TemplateGuestSteps />
          </StepsWrapper>
        )}

        {currentStepName === 'templates' && (
          <>
            {showTitleAb && <Title>Please choose a template</Title>}
            <HeaderButtonsContainer>
              {skipTemplatesVariant === 'v1' && pickTemplateAfterUploadVariant !== 'v2' && (
                <CloseButton aria-label="Close" href={homepageUrl} onClick={handleExitButton}>
                  <Icon.CloseLarge />
                </CloseButton>
              )}
              {(skipTemplatesVariant === 'v2' || pickTemplateAfterUploadVariant === 'v2') && (
                <SkipButton onClick={handleSkipButton}>Skip</SkipButton>
              )}
            </HeaderButtonsContainer>
          </>
        )}
      </Navbar>
      <Main>{children}</Main>
    </Container>
  )
}

export default TemplatesLayout
